module.exports = __webpack_public_path__ + "static/media/live07_01_2022.6c34c9a6.jpg";